import { httpClient } from '../http-client/http-client';
import { apiConstants } from './apiConstants';
import { store } from '@/app/shared/stores/store';

const GetTeeConfigByCourseId = (id) => {
  const url = `${apiConstants.GetAll}?Keyword=${id}&SkipCount=0&MaxResultCount=100000`;

  return httpClient.get(url).then(result => result.data.result.items);
};

const GetDaysByTeeConfigId = (id) => {
  const url = `${apiConstants.GetAllDays}?id=${id}`;

  return httpClient.get(url).then(result => result.data.result);
};

const CreateTeeConfiguration = (courseId, startDate, endDate, maxPlayers) => {
  const url = apiConstants.Create;

  const teeConfig = {
    courseId,
    startDate,
    endDate,
    maxPlayers,
  };

  return httpClient.post(url, teeConfig).then(result => result.data.result);
};

const CreateTeeConfigurationDay = (teeConfigurationId, dayOfWeek, startTime, endTime) => {
  const url = apiConstants.CreateDay;

  const teeConfigDay = {
    teeConfigurationId,
    dayOfWeek,
    startTime,
    endTime,
    tenantId: store.state.user.tenantId,
  };

  return httpClient.post(url, teeConfigDay).then(result => result.data);
};

const UpdateTeeConfigurationDay = (id, teeConfigurationId, dayOfWeek, startTime, endTime, tenantId, existingDay = null) => {
  const url = apiConstants.UpdateDay;

  // Use existing day data if available, otherwise use defaults
  const now = new Date().toISOString();
  const teeConfigDay = {
    id,
    tenantId: tenantId || store.state.user.tenantId,
    teeConfigurationId,
    dayOfWeek,
    startTime,
    endTime,
    isDeleted: existingDay ? existingDay.isDeleted : false,
    deleterUserId: existingDay ? (existingDay.deleterUserId || 0) : 0,
    deletionTime: existingDay ? (existingDay.deletionTime || null) : null,
    lastModificationTime: now,
    lastModifierUserId: 0,
    creationTime: existingDay ? (existingDay.creationTime || now) : now,
    creatorUserId: existingDay ? (existingDay.creatorUserId || 0) : 0,
  };

  return httpClient.post(url, teeConfigDay).then(result => result.data);
};

const OverrideTeeConfigurationDay = (teeConfigurationId, date, startTime, endTime) => {
  const url = apiConstants.OverrideDay;

  const teeConfigDay = {
    teeConfigurationId,
    date,
    startTime,
    endTime,
  };

  return httpClient.post(url, teeConfigDay).then(result => result.data);
};

const GetConfigurationDayOverride = (teeConfigurationId, date) => {
  const url = `${apiConstants.GetOverrideDay}?teeConfigId=${teeConfigurationId}&date=${date.toISOString()}`;

  return httpClient.get(url).then(result => result.data.result);
};

const DeleteTeeConfigurationDay = (id) => {
  const url = `${apiConstants.DeleteDay}?id=${id}`;

  return httpClient.post(url).then(result => result.data);
};

export {
  GetTeeConfigByCourseId, CreateTeeConfiguration, CreateTeeConfigurationDay, GetDaysByTeeConfigId, UpdateTeeConfigurationDay, DeleteTeeConfigurationDay, OverrideTeeConfigurationDay, GetConfigurationDayOverride,
};
